import {FirebaseError} from 'firebase/app';

/** Firebase Auth error code returned when a disabled account signs in. */
export const USER_DISABLED_ERROR_CODE = 'auth/user-disabled';

/** Popup error codes caused by the user closing or re-opening the popup. */
export const POPUP_DISMISSED_ERROR_CODES: ReadonlySet<string> = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]);

/**
 * Message shown to a disabled account on sign-in. It is also the translation
 * key, so callers pass it through `t`.
 */
export const ACCOUNT_DISABLED_MESSAGE =
  'This account has been disabled. For help, contact codeinplace@stanford.edu.';

/**
 * Picks the untranslated message to show for a failed sign-in or a failed
 * request for a sign-in or password-reset email.
 *
 * @param error The value a Firebase Auth call rejected with.
 * @param options.fallback Message for any error other than a disabled
 *     account. When omitted, the error's own message is used, or its string
 *     form when it is not an `Error`.
 * @return `ACCOUNT_DISABLED_MESSAGE` for a disabled account, otherwise the
 *     fallback.
 * @throws Never.
 */
export function getSignInErrorMessage(
  error: unknown,
  {fallback}: {fallback?: string} = {},
): string {
  if (
    error instanceof FirebaseError &&
    error.code === USER_DISABLED_ERROR_CODE
  ) {
    return ACCOUNT_DISABLED_MESSAGE;
  }
  if (fallback !== undefined) {
    return fallback;
  }
  return error instanceof Error ? error.message : String(error);
}
